import React, { useEffect, useState } from 'react';
import './Home.css';
function useScrollReveal(selector, className = 'scroll-reveal') {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);
    if (!('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add(className));
      return;
    }
    const observer = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(className);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector, className]);
}
const TYPED_TEXTS = [
  'Fernando Iglesias Iglesias',
  'Hello! I\'m not an AI, I\'m a Full Stack Developer.'
];

const Home = () => {
  const [typed, setTyped] = useState(['', '']);
  const [typingDone, setTypingDone] = useState(false);

  useEffect(() => {
    document.body.classList.add('page-fade-in');
    return () => document.body.classList.remove('page-fade-in');
  }, []);

  useEffect(() => {
    document.body.classList.add('page-fade-in');
    return () => document.body.classList.remove('page-fade-in');
  }, []);

  useScrollReveal('.experience-card', 'scroll-reveal');
  useScrollReveal('.project-card', 'scroll-reveal');
  useScrollReveal('.skills-group', 'scroll-reveal');

  useEffect(() => {
    let char = 0;
    const current = ['', ''];
    const timeouts = [];

    function typeLine(line) {
      if (char <= TYPED_TEXTS[line].length) {
        current[line] = TYPED_TEXTS[line].slice(0, char);
        setTyped([ ...current ]);
        timeouts.push(setTimeout(() => typeLine(line), 40)); 
        char++;
      } else if (line === 0) {
        char = 0;
        setTimeout(() => typeLine(1), 200);
      } else {
        setTimeout(() => setTypingDone(true), 200);
      }
    }
    typeLine(0);
    return () => timeouts.forEach(clearTimeout);
  }, []);

  return (
    <section className="home">
      <div className="home-content">
            <div className='profile-container'>
            <div className="profile">
                <div className="profile-picture-wrapper">
                  <img src="/foto_personal.jpeg" alt="Foto de perfil" className="profile-picture large-profile-picture" />
                </div>
                <div className="profile-text">
                  <h1>
                    {typed[0]}
                    {(!typingDone && typed[0].length === TYPED_TEXTS[0].length) ? null : (!typingDone && (typed[0].length < TYPED_TEXTS[0].length)) ? <span className="typed-cursor">|</span> : null}
                  </h1>
                  <p>
                    {typed[1]}
                    {!typingDone && typed[0].length === TYPED_TEXTS[0].length && <span className="typed-cursor">|</span>}
                  </p>
                </div>
                <div className="profile-actions" style={{ opacity: typingDone ? 1 : 0, transition: 'opacity 0.6s 0.1s' }}>
                <div className="cv-section">
                    <button className="cv-button" onClick={() => window.open('/cv.pdf', '_blank')}>Download CV</button>
                    <div className="social-links">
                    <a href="https://www.linkedin.com/in/fernando-iglesias-iglesias2/" target="_blank" rel="noopener noreferrer">
                        <img src="/linkedin.png" alt="LinkedIn" className="linkedin" />
                    </a>
                    <a href="https://github.com/FernandoIglesiasIglesias" target="_blank" rel="noopener noreferrer">
                        <img src="/github.png" alt="GitHub" className="github" />
                    </a>
                    </div>
                    <p className="email-text">
                      Email: fernando.iglesias2@hotmail.com
                      <button
                        className="copy-email-btn"
                        title="Copy email to clipboard"
                        onClick={() => {
                          navigator.clipboard.writeText('fernando.iglesias2@hotmail.com');
                          if (window && window.document) {
                            const btn = document.querySelector('.copy-email-btn');
                            if (btn) {
                              btn.innerText = 'Copied!';
                              setTimeout(() => { btn.innerText = '📋'; }, 1200);
                            }
                          }
                        }}
                        style={{ marginLeft: 10, background: 'none', border: 'none', cursor: 'pointer', color: '#00d4ff', fontSize: '1.1em', verticalAlign: 'middle' }}
                      >📋</button>
                    </p>
                </div>
                </div>
            </div>
            </div>
            <div className="about" style={{ opacity: typingDone ? 1 : 0, transition: 'opacity 0.6s 0.3s' }}>
            <h2>
                <img src="/sobre_mi.png" alt="About me" className="about-logo" /> About Me
            </h2>
            <p>I'm a Full Stack Developer with experience building robust, efficient, and scalable applications. On the backend, I work primarily with Java, Spring Boot, Kafka, and event-driven architectures, developing solid, secure services ready for high performance. On the frontend, I have experience with JavaScript, React, TypeScript, Angular, and other modern technologies that enable the creation of dynamic, accessible interfaces centered on user experience.</p>
            <p>I'm passionate about software development at all stages: from functional analysis and architecture design, to implementation, testing, deployment, and maintenance. I enjoy creating clean and well-structured solutions, applying best practices, design patterns, and agile methodologies to ensure reliable and quality products.</p>
            <p>I'm always learning continuously, exploring new tools, frameworks, and approaches that allow me to keep growing professionally and provide greater value in each project. My goal is to develop software that truly solves problems, improves processes, and delivers an exceptional final experience.</p>
            <h3>
                <img src="/estudios.png" alt="Education" className="studies-logo" /> Education
            </h3>
            <ul>
                <li>
                <img src="/udc.png" alt="UDC Logo" className="institution-logo" /> Bachelor's Degree in Computer Engineering from the University of A Coruña (2021-2025).
                </li>
                <li>
                <img src="/logo_viu.png" alt="VIU Logo" className="institution-logo" /> Master's Degree in Web Application and Services Development from the International University of Valencia (In progress).
                </li>
            </ul>
            </div>
            </div> {/* cierre de home-content */}
      <div
        className="experience-section"
        style={{
          opacity: typingDone ? 1 : 0,
          transition: 'opacity 0.6s 0.4s',
          display: typingDone ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2 style={{justifyContent: 'flex-start', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px'}}>
          <span role="img" aria-label="Experience" style={{marginRight: '8px'}}>💼</span> Experience
        </h2>
        <div className="experience-list">
          <div className="experience-card">
            <div className="experience-icon">
              <img src="/marosa.png" alt="MarosaVat" className="experience-logo" />
            </div>
            <div>
              <h3>Full Stack Developer</h3>
              <p className="company-name">MarosaVat</p>
              <p className="experience-period">September 2025 - Present</p>
              <p>Developed and enhanced new features for Marosa’s Vatify platform, a
web application used to prepare and submit VAT returns to various tax authorities. Contributed to the development of microservices using Java and Kafka, as well as frontend features built with Angular. Produced SQL queries to support reporting needs for the business team to integrate API services into the platform.</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="projects-section"
        style={{
          opacity: typingDone ? 1 : 0,
          transition: 'opacity 0.6s 0.6s',
          display: typingDone ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2 style={{justifyContent: 'flex-start', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px'}}>
          <span role="img" aria-label="Projects" style={{marginRight: '8px'}}>💻</span> My Projects
        </h2>
        <div className="projects-list">
          <div className="project-card">
            <div className="project-icon">🎬</div>
            <div>
              <h3>Cinematrix</h3>
              <p>A personalized movie management application developed with Java, Spring Boot, Hibernate, and JPA on the backend, and JavaScript + React on the frontend. It uses external APIs to obtain information about movies, actors, and directors, and implements a proprietary personalized recommendation algorithm based on user interactions.</p>
              <div className="project-video-centered">
                <div className="project-video">
                  <iframe width="360" height="203" src="https://www.youtube.com/embed/BPJui4inpik" title="Demo Cinematrix" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>
                <div className="project-links project-links-centered">
                  <a href="https://github.com/FernandoIglesiasIglesias/Java-Web-Application-for-personalized-movie-management" target="_blank" rel="noopener noreferrer" className="project-link-btn">GitHub Repository</a>
                </div>
              </div>
            </div>
          </div>
          <div className="project-card">
            <div className="project-icon">💼</div>
            <div>
              <h3>Personal Portfolio</h3>
              <p>My professional website where I showcase my projects, skills, and experience as a software engineer.</p>
              <div className="project-links project-links-centered">
                <a href="https://github.com/FernandoIglesiasIglesias/myportfolio" target="_blank" rel="noopener noreferrer" className="project-link-btn">GitHub Repository</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="skills-section"
        style={{
          opacity: typingDone ? 1 : 0,
          transition: 'opacity 0.6s 0.8s',
          display: typingDone ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2 style={{justifyContent: 'flex-start', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px'}}>
          <span className="skills-logo" role="img" aria-label="Skills" style={{marginRight: '8px', fontWeight: 'bold', fontSize: '1.5em'}}>&lt;/&gt;</span> Skills
        </h2>
        <ul className="skills-list">
          <li className="skills-group">
            <strong className="skills-title">Frontend</strong>
            <div className="skills-box skills-badges-row">
              <span className="skill-badge"><img src="/javascript.webp" alt="JavaScript" className="skill-icon" />JavaScript</span>
              <span className="skill-badge"><img src="/Typescript.png" alt="TypeScript" className="skill-icon" />TypeScript</span>
              <span className="skill-badge"><img src="/react.png" alt="React" className="skill-icon" />React</span>
              <span className="skill-badge"><img src="/Angular.png" alt="Angular" className="skill-icon" />Angular</span>
              <span className="skill-badge"><img src="/html5.png" alt="HTML5" className="skill-icon" />HTML5</span>
              <span className="skill-badge"><img src="/css.png" alt="CSS3" className="skill-icon" />CSS3</span>
            </div>
          </li>
          <li className="skills-group">
            <strong className="skills-title">Backend</strong>
            <div className="skills-box skills-badges-row">
              <span className="skill-badge"><img src="/apirest.png" alt="Java" className="skill-icon" />Java</span>
              <span className="skill-badge"><img src="/springboot.png" alt="Spring Boot" className="skill-icon" />Spring Boot</span>
              <span className="skill-badge"><img src="/kafka.png" alt="Kafka" className="skill-icon" />Kafka</span>
              <span className="skill-badge"><img src="/jpa.png" alt="JPA" className="skill-icon" />Hibernate & JPA</span>
            </div>
          </li>
          <li className="skills-group">
            <strong className="skills-title">Databases</strong>
            <div className="skills-box skills-badges-row">
              <span className="skill-badge"><img src="/mysql.png" alt="MySQL" className="skill-icon" />MySQL</span>
              <span className="skill-badge"><img src="/MariaDB_Logo.png" alt="MariaDB" className="skill-icon" />MariaDB</span>
              <span className="skill-badge"><img src="/postgre.png" alt="PostgreSQL" className="skill-icon" />PostgreSQL</span>
              <span className="skill-badge"><img src="/oracle.png" alt="Oracle Database" className="skill-icon" />Oracle</span>
            </div>
          </li>
          <li className="skills-group">
            <strong className="skills-title">Tools</strong>
            <div className="skills-box skills-badges-row">
              <span className="skill-badge"><img src="/git.webp" alt="Git" className="skill-icon" />Git</span>
              <span className="skill-badge"><img src="/postman.png" alt="Postman" className="skill-icon" />Postman</span>
              <span className="skill-badge"><img src="/docker.png" alt="Docker" className="skill-icon" />Docker</span>
              <span className="skill-badge"><img src="/jenkins.png" alt="Jenkins" className="skill-icon" />Jenkins</span>
              <span className="skill-badge"><img src="/redmine.png" alt="Redmine" className="skill-icon" />Redmine</span>
              <span className="skill-badge"><img src="/jira.png" alt="Jira" className="skill-icon" />Jira</span>
            </div>
          </li>
          <li className="skills-group">
            <strong className="skills-title">Others</strong>
            <div className="skills-box skills-badges-row">
              <span className="skill-badge"><img src="/apirest.png" alt="APIs REST" className="skill-icon" />APIs REST</span>
              <span className="skill-badge"><img src="/csharp.png" alt="C#" className="skill-icon" />C#</span>
              <span className="skill-badge"><img src="/net.webp" alt=".NET" className="skill-icon" />.NET</span>
              <span className="skill-badge"><img src="/scrum.png" alt="Scrum" className="skill-icon" />Scrum</span>
            </div>
          </li>
        </ul>
      </div>

      <div
        className="certificates-section"
        style={{
          opacity: typingDone ? 1 : 0,
          transition: 'opacity 0.6s 1.0s',
          display: typingDone ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2>
          <span className="certificates-logo" role="img" aria-label="Certificates">📄</span> Certificates
        </h2>
        <ul className="certificates-list" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 0, margin: 0 }}>
          <li className="certificate-card">
            <div className="certificate-icon" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <img src="/scrum.png" alt="Scrum" className="certificate-img" />
            </div>
            <div style={{textAlign: 'left'}}>
              <h3 className="certificate-name">Scrum Fundamentals Certified (SFC)</h3>
              <p className="certificate-desc">Official certification in Scrum fundamentals awarded by SCRUMstudy.</p>
              <div className="certificate-links">
                <a
                  href="https://c46e136a583f7e334124-ac22991740ab4ff17e21daf2ed577041.ssl.cf1.rackcdn.com/Certificate/ScrumFundamentalsCertified-FernandoIglesiasIglesias-1095889.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="certificate-link-btn"
                >View Certificate</a>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </section>
  );
};

export default Home;
